



























































import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import Component from 'vue-class-component';
import { SwModal, SwModalBody, SwModalFooter } from '@sonicwall/unified-ui-framework/src/shared/sw-modal';
import { SwButton } from '@sonicwall/unified-ui-framework/src/shared/sw-button';
import { SwTextfield } from '@sonicwall/unified-ui-framework/src/shared/sw-textfield';
import { Prop } from 'vue-property-decorator';
import { InfoState } from '@/core';
import SwPwInput from './sw-pw-input.vue';

const cssPrefix = 'off-two-factor-auth';
@Component({
  components: {
    SwModal,
    SwModalBody,
    SwModalFooter,
    SwButton,
    SwTextfield,
    SwPwInput,
  },
})
export default class OffTwoFactorApp extends SwExtendedVue {
  cssPrefix = cssPrefix;
  @Prop({ required : true })
  displayOffTfa : any;
  tfa : any = {
    isOverRide: 'YES',
    tfaAuthCode: '',
    tfaMode: 'OFF',
  };
  isSubmitted : boolean = false;

  checkValidation() {
    let validateFlag = true;
    if (this.tfa.tfaAuthCode.trim().length === 0) {
      validateFlag = false;
    }
    return validateFlag;
  }

  disableTFA() {
    this.isSubmitted = true;
    if (this.checkValidation()) {
      const payload = {
        isOverRide: this.tfa.isOverRide,
        tfaAuthCode: this.tfa.tfaAuthCode.trim(),
        tfaMode: this.tfa.tfaMode,
      };
      this.$store.dispatch('SnbProfileStoreModule/setTFAPreference', payload)
      .then((resp : any) => {
        console.warn(resp);
        this.$store.commit('stopLoading');
        if (resp.operationStatus === 'OK') {
          const message : InfoState = { infoMsg : resp.msgDesc, infoType: 'success' };
          this.$store.commit('enqueueMessage', message);
          this.$emit('close-modal', false);
        } else {
          const message : InfoState = { infoMsg : resp.msgDesc, infoType: 'failed' };
          this.$store.commit('enqueueMessage', message);
        }
      });
    }
  }

  closeDialog() {
    this.$emit('close-modal', true);
  }

  cancel() {
    this.$emit('close-modal', true);
  }
}
